import { decode } from '~/common/helpers/jwt/jwt';

export function tokenIsValid(userToken?: string) {
  try {
    const expiration = decode(userToken).exp * 1000;
    return !Number.isNaN(expiration) && +new Date(expiration) > +new Date();
  } catch (error) {
    return false;
  }
}
